import axios from 'axios';

const state = {
  suggestions: [],
  webAds: [],
};

const getters = {
  getSuggestions(state) {
    return state.suggestions;
  },
  getWebAds(state) {
    return state.webAds;
  },
};

export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
export const SET_WEB_ADS = 'SET_WEB_ADS';

const mutations = {
  [SET_SUGGESTIONS](state, suggestions) {
    state.suggestions = suggestions;
  },
  [SET_WEB_ADS](state, webAds) {
    state.webAds = webAds;
  },
};

const actions = {
  fetchSuggestions({ commit }, query) {
    return axios
      .get('/api/b/suggest', {
        params: {
          q: query,
        },
      })
      .then(res => {
        const data = res.data;
        const suggestions = data.map(suggestion => {
          return JSON.parse(suggestion);
        });
        commit(SET_SUGGESTIONS, suggestions);
      })
      .catch(err => {
        console.log(err);
      });
  },
  setWebAds({ commit }, webAds) {
    commit(SET_WEB_ADS, webAds);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
